"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setValidDimension = setValidDimension; // Sets numerical values to pixels, otherwise passes provided string

function setValidDimension(measurement) {
  if (typeof measurement === "string") return measurement;
  return "".concat(measurement, "px");
}